const dropdownServices = [
  {
    label: "FDM 3D Printing",
    value: "3D-Printing-fdm",
  },
  {
    label: "SLA 3D Printing",
    value: "3D-Printing-sla",
  },
  {
    label: "Laser Cutting",
    value: "Laser-Cutting",
  },
  {
    label: "PCB Manufacturing",
    value: "PCB-Manufacturing",
  },
  {
    label: "Product Development",
    value: "Product-Development",
  },
  {
    label: "Silicon Molding",
    value: "Silicon-Molding",
  },
];

export default dropdownServices;
